import type {GroupsSearchParams} from '@/types/groups';

/**
 * Maps groups search params to `list_admin` query params.
 * Excludes tokens (handled by buildMbApiUrl) and pagination (per_page/page),
 * which each caller adds. Shared by the SWR fetcher and the legacy getGroups().
 */
export function buildGroupsFilterParams(
    params: GroupsSearchParams
): Record<string, string | number> {
    const query: Record<string, string | number> = {};
    if (params.name) query.name = params.name;
    if (params.state) query.state = params.state;
    if (params.sort_by) query.sort_by = params.sort_by;
    if (params.sort_order) query.sort_order = params.sort_order;
    if (params.tagId) query.pg_library_ids = params.tagId;
    if (params.email) query.email = params.email;
    if (params.user_id) query.user_id = params.user_id;
    return query;
}
